import { useEffect, useState } from 'react';
import { Platform } from 'react-native';

export const useFetchMedia = ({ uri, headers }: Props) => {
	const [localUri, setLocalUri] = useState<string | null>();

	useEffect(() => {
		const abortController = new AbortController();
		const fetchMedia = async () => {
			if (!uri) return null;

			if (!headers || Platform.OS !== 'web') {
				return setLocalUri(uri);
			}

			try {
				const response = await fetch(uri, {
					headers,
					mode: 'cors',
					signal: abortController.signal,
					cache: 'force-cache',
				});
				const blob = await response.blob();
				const objectUri = URL.createObjectURL(blob);

				setLocalUri(objectUri);
			} catch (error) {
				console.error(error);

				return setLocalUri(null);
			}
		};

		void fetchMedia();

		return function cleanUp() {
			abortController.abort();
		};
	}, [uri, headers]);

	return localUri;
};

type Props = {
	uri?: string;
	headers?: { [key: string]: string };
};
